import moment from 'moment';

export const getTimeInUserTimeZone = (time, timezone, format) => {
  const timeInTimezone = moment(time, 'x').tz(timezone);
  return format ? timeInTimezone.format(format) : timeInTimezone.valueOf();
};
